import React, { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate, Navigate } from "react-router-dom";

import Admin from "./Admin_Route";
import SubAdmin from "./Sub_Admin_Route";
import Client from "./User_Route";
import Superadmin from "./Super_Admin_Route";

import ForgetPassword from "../layout/Auth/ForgetPassword";
import UpdatePassword from "../layout/Auth/UpdatePassword";
import NotFound from "../layout/Auth/Not_Found";
import NewSignUp from "../layout/Sign_Up_Users/signUp";
import Login from "../layout/Auth/LoginFull";
// import Login from "../layout/Auth/login3";

import Home from "../Home";

const Routing = ({companyLogo}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const accessToken = JSON.parse(localStorage.getItem("user_details"));
  const roles = JSON.parse(localStorage.getItem("user_role"));
  const gotodashboard = JSON.parse(localStorage.getItem("gotodashboard"));
  const user_role_goTo = JSON.parse(localStorage.getItem("user_role_goTo"));



  // ✅ Auto-redirect logic
  useEffect(() => {
    const publicRoutes = ["/login", "/forget", "/newsignup", "/update"];
    const isPublic = publicRoutes.some((path) =>
      location.pathname.startsWith(path)
    );

    if (isPublic) return;

    if (!accessToken) {
      navigate("/");
      return;
    }

    if (roles && location.pathname === "/login") {
      if (roles === "ADMIN") navigate("/admin/dashboard");
      else if (roles === "USER") navigate("/client/dashboard");
      else if (roles === "SUBADMIN") navigate("/subadmin/clients");
      else if (roles === "SUPERADMIN") navigate("/super/dashboard");
    }

    if (gotodashboard != null) {
      if (user_role_goTo === "USER" && location.pathname === "/")
        navigate("/client/dashboard");
      else if (user_role_goTo === "SUBADMIN" && location.pathname === "/")
        navigate("/subadmin/clients");
    }
  }, [location.pathname]);

  return (
    <Routes>
      {/* 🌐 Home route */}
     {companyLogo == 1 ? <Route path="/" element={ <Home />} /> : <Route path="/" element={ <Login />} /> }

      {/* 🔐 Protected routes (role-based) */}
      <Route
        path="/admin/*"
        element={roles === "ADMIN" ? <Admin /> : <Login />}
      />
      <Route
        path="/client/*"
        element={
          roles === "USER" || gotodashboard ? <Client /> : <Login />
        }
      />
      <Route
        path="/subadmin/*"
        element={
          roles === "SUBADMIN" || gotodashboard ? <SubAdmin /> : <Login />
        }
      />
      <Route
        path="/super/*"
        element={roles === "SUPERADMIN" ? <Superadmin /> : <Login />}
      />

      {/* 🧭 Public routes */}
      <Route
        path="/login"
        element={
          roles === "ADMIN" ? (
            <Navigate to="/admin/dashboard" replace />
          ) : roles === "USER" ? (
            <Navigate to="/client/dashboard" replace />
          ) : (
            <Login />
          )
        }
      />
      <Route path="/newsignup/:id" element={<NewSignUp />} />
      <Route path="/newsignup" element={<NewSignUp />} />
      <Route path="/forget" element={<ForgetPassword />} />
      <Route path="/update/:id" element={<UpdatePassword />} />

      {/* ⚠️ Catch all unknown routes → Not Found */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Routing;
